import { normalizeString } from './normalizeString'

const descendingComparator = (a, b, orderBy) => {
  const optionA =
    typeof a[orderBy] === 'string'
      ? normalizeString({ term: a[orderBy] })
      : orderBy.includes('fatigueLevel8h')
        ? a[orderBy].fatigueLevel
        : a[orderBy]
  const optionB =
    typeof b[orderBy] === 'string'
      ? normalizeString({ term: b[orderBy] })
      : orderBy.includes('fatigueLevel8h')
        ? b[orderBy].fatigueLevel
        : b[orderBy]

  if (optionB < optionA) return -1
  if (optionB > optionA) return 1

  return 0
}

export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy)
}

export const shouldDefineMax = ({ flatData, gateValue, maxChartValue }) =>
  flatData.every(value => value <= gateValue) ? {} : { max: maxChartValue }
